module.exports = __webpack_public_path__ + "static/media/creditcard.2e8b83ff.svg";